export interface Logger {
  debug(primaryMessage: string, ...supportingData: unknown[]): void;
  warn(primaryMessage: string, ...supportingData: unknown[]): void;
  error(primaryMessage: string, ...supportingData: unknown[]): void;
  info(primaryMessage: string, ...supportingData: unknown[]): void;
}
